'use strict';

exports.__esModule = true;
exports.Hint = exports.Percent = exports.ProgressBar = exports.ProgressTrack = exports.Title = exports.InlineSpinner = exports.Glyph = exports.IconBubble = exports.FeedbackBox = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  background: ', ';\n  border: ', ';\n'], ['\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: ', ';\n  padding: ', ';\n  border-radius: ', ';\n  background: ', ';\n  border: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 44px;\n  height: 44px;\n  border-radius: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ', ';\n'], ['\n  width: 44px;\n  height: 44px;\n  border-radius: ', ';\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 20px;\n  line-height: 1;\n  font-weight: ', ';\n  color: ', ';\n'], ['\n  font-size: 20px;\n  line-height: 1;\n  font-weight: ', ';\n  color: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  box-sizing: border-box;\n  width: 26px;\n  height: 26px;\n  border: 3px solid ', ';\n  border-top-color: ', ';\n  border-radius: ', ';\n  animation: uploadFeedbackSpin 0.9s infinite linear;\n\n  @keyframes uploadFeedbackSpin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n'], ['\n  box-sizing: border-box;\n  width: 26px;\n  height: 26px;\n  border: 3px solid ', ';\n  border-top-color: ', ';\n  border-radius: ', ';\n  animation: uploadFeedbackSpin 0.9s infinite linear;\n\n  @keyframes uploadFeedbackSpin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n']),
    _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 15px;\n  font-weight: ', ';\n  color: ', ';\n  word-break: break-word;\n'], ['\n  font-size: 15px;\n  font-weight: ', ';\n  color: ', ';\n  word-break: break-word;\n']),
    _templateObject6 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  max-width: 220px;\n  height: 6px;\n  border-radius: ', ';\n  background: ', ';\n  overflow: hidden;\n'], ['\n  width: 100%;\n  max-width: 220px;\n  height: 6px;\n  border-radius: ', ';\n  background: ', ';\n  overflow: hidden;\n']),
    _templateObject7 = _taggedTemplateLiteralLoose(['\n  height: 100%;\n  border-radius: ', ';\n  background: ', ';\n  transition: width 0.2s ease;\n'], ['\n  height: 100%;\n  border-radius: ', ';\n  background: ', ';\n  transition: width 0.2s ease;\n']),
    _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-size: 13px;\n  font-weight: ', ';\n  color: ', ';\n'], ['\n  font-size: 13px;\n  font-weight: ', ';\n  color: ', ';\n']),
    _templateObject9 = _taggedTemplateLiteralLoose(['\n  font-size: 13px;\n  color: ', ';\n'], ['\n  font-size: 13px;\n  color: ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// F3 (Upload-Feedback 2026-06): wiederverwendbare 4-Zustands-Box (idle/uploading/
// success/error) nach Mockup ③. Token-basiert, i18n-agnostisch. Rot ist ausschliesslich
// der Fehlerzustand (entkoppeltes errorColor), Erfolg gruen, Upload navy.
// Robust gegen shared-only-Kontext: radius/elevation mit Fallback auf shared-Tokens.

// Farbton je Zustand. Hex-Alpha-Suffix (8-stellig) fuer die hellen Flaechen, damit der
// Ton automatisch dem jeweiligen Theme-Token folgt (errorColor wird in education ueber
// shared gemerged: #d92b3c).
var tone = function tone(theme, state) {
  return {
    idle: {
      fg: theme.grayA0, bg: theme.grayF7, border: theme.grayE6, dashed: true
    },
    uploading: {
      fg: theme.secondary, bg: theme.secondary + '0a', border: theme.secondary, dashed: true
    },
    success: {
      fg: theme.green, bg: theme.green + '1f', border: theme.green, dashed: false
    },
    error: {
      fg: theme.errorColor, bg: theme.errorColor + '14', border: theme.errorColor, dashed: false
    }
  }[state] || {};
};

var radiusMd = function radiusMd(_ref) {
  var theme = _ref.theme;
  return theme.radiusMd || theme.borderRadiusDefault;
};
var radiusPill = function radiusPill(_ref2) {
  var theme = _ref2.theme;
  return theme.radiusPill || '999px';
};

var FeedbackBox = exports.FeedbackBox = _styledComponents2.default.div(_templateObject, (0, _spacing.space)(8), (0, _spacing.space)(18, 20), radiusMd, function (_ref3) {
  var theme = _ref3.theme,
      state = _ref3.state;
  return tone(theme, state).bg;
}, function (_ref4) {
  var theme = _ref4.theme,
      state = _ref4.state;

  var t = tone(theme, state);
  return '2px ' + (t.dashed ? 'dashed' : 'solid') + ' ' + t.border;
});

var IconBubble = exports.IconBubble = _styledComponents2.default.div(_templateObject2, function (_ref5) {
  var theme = _ref5.theme;
  return theme.borderRadiusRound;
}, function (_ref6) {
  var theme = _ref6.theme,
      state = _ref6.state;
  return state === 'uploading' ? 'transparent' : tone(theme, state).fg + '22';
});

var Glyph = exports.Glyph = _styledComponents2.default.span(_templateObject3, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeightUpperBold;
}, function (_ref8) {
  var theme = _ref8.theme,
      state = _ref8.state;
  return tone(theme, state).fg;
});

// Eigener Inline-Spinner (relative) statt des app-weiten <Spin> (position:absolute,
// wuerde den IconBubble nicht sauber zentrieren). Navy-Akzent auf grauem Track.
var InlineSpinner = exports.InlineSpinner = _styledComponents2.default.div(_templateObject4, function (_ref9) {
  var theme = _ref9.theme;
  return theme.grayE6;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.secondary;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.borderRadiusRound;
});

var Title = exports.Title = _styledComponents2.default.div(_templateObject5, function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeightMedium;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.textColor;
});

var ProgressTrack = exports.ProgressTrack = _styledComponents2.default.div(_templateObject6, radiusPill, function (_ref14) {
  var theme = _ref14.theme;
  return theme.grayE6;
});

var ProgressBar = exports.ProgressBar = _styledComponents2.default.div(_templateObject7, radiusPill, function (_ref15) {
  var theme = _ref15.theme;
  return theme.secondary;
});

var Percent = exports.Percent = _styledComponents2.default.div(_templateObject8, function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontWeightMedium;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.secondary;
});

var Hint = exports.Hint = _styledComponents2.default.div(_templateObject9, function (_ref18) {
  var theme = _ref18.theme,
      state = _ref18.state;
  return state === 'error' ? theme.errorColor : theme.grayA0;
});